import {getLabelByField} from "../../utils/fields/funds.js";

const columns = [
	{
		id: 'Name',
		name: 'Fund',
		sortable: true,
		selector: row => row.Name,
		cell: row => row.Name,
		width: '1fr'
	}, {
		id: 'Category__c',
		name: 'Category',
		sortable: true,
		selector: row => row.Category__c,
		cell: row => row.Category__c,
		width: '200px'
	}, {
		id: 'Priority__c',
		name: 'Priority',
		sortable: true,
		selector: row => row.Priority__c,
		cell: row => row.Priority__c,
		width: '200px'
	}, {
		id: 'Type__c',
		name: 'Type',
		sortable: true,
		selector: row => row.Type__c,
		cell: row => row.Type__c,
		width: '200px'
	}, {
		id: 'Amount__c',
		name: 'Amount',
		sortable: true,
		selector: row => row.Amount__c,
		cell: row => row.Amount__c,
		width: '200px'
	}, {
		id: 'Status__c',
		name: 'Status',
		sortable: true,
		selector: row => row.Status__c,
		cell: row => row.Status__c,
		width: '200px'
	}, {
		id: 'Due_Date__c',
		name: 'Due Date',
		sortable: true,
		selector: row => row.Due_Date__c,
		cell: row => row.Due_Date__c,
		width: '150px'
	}
];

export default columns;